/* Marcas — C · Curaduría editorial (mock: marcas-options.jsx MarcasC).
   Hero "marca del momento" + En foco (3 mini-heros) + Más marcas (mosaico) +
   directorio de texto. Todo se calcula de window.CATALOG en runtime.
   Fotos: editorial del bundle donde la marca coincide (8 marcas); foto de
   producto representativa como respaldo en el mosaico. */
(function(){
  var WA_DOOR = "https://wa.me/528186916631?text=Hola%2C%20busco%20una%20marca%20que%20no%20veo%20en%20la%20p%C3%A1gina%2C%20%C2%BFme%20la%20pueden%20conseguir%3F";

  /* marca real (string exacto del catálogo) -> foto editorial del bundle (8 de 12 coinciden) */
  /* marca real → foto editorial (assets del theme). Inyectado por la sección brands-index. */
  var PHOTO = window.MARCAS_PHOTOS || {};
  /* hero y En foco SIN texto secundario (cambio Kike 12/07) — solo nombre + CTA */

  function arrow(s){ return '<svg width="'+s+'" height="'+s+'" viewBox="0 0 16 16" fill="none" aria-hidden="true"><line x1="2" y1="8" x2="12.4" y2="8" stroke="currentColor" stroke-width="1.5"/><polyline points="8,3.6 12.8,8 8,12.4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
  function pcs(n){ return n === 1 ? "1 modelo" : n + " modelos"; }
  function url(b){ return COLL + "?marca=" + encodeURIComponent(b); }
  function srcFor(it){ return PHOTO[it.name] || it.img; }
  function imgTag(it){
    var s = srcFor(it);
    return s ? '<img loading="lazy" src="' + s + '" alt="' + it.name + '">' : '<span class="ph-tag">FOTO PENDIENTE</span>';
  }
  function sechead(title, note, dir){
    return '<div class="mc-sechead' + (dir ? ' mc-sechead--dir' : '') + '"><h2>' + title + '</h2>' +
      '<span class="mc-sechead-note">' + note + '</span></div>';
  }

  function compute(products){
    var por = {};
    products.forEach(function(p){ (por[p.brand] = por[p.brand] || []).push(p); });
    var items = Object.keys(por).map(function(b){
      var ps = por[b];
      var f = ps.find(function(p){ return p.images && p.images.length; });
      return { name: b, count: ps.length, img: f ? f.images[0] : null };
    });
    items.sort(function(a, b){ return b.count - a.count || a.name.localeCompare(b.name, "es"); });
    return items;
  }
  window.MARCAS = { compute: compute, modelos: pcs };

  document.addEventListener("DOMContentLoaded", function(){
    var root = document.getElementById("mcRoot");
    if (!root) return;
    window.onCatalog(function(){
    var all = compute(window.CATALOG.products);
    /* secciones visuales: solo marcas con 4+ modelos (Kike 16/07) */
    var items = all.filter(function(i){ return i.count > 3; });
    /* directorio de texto "Todas las marcas": las de 3+ modelos, alfabético (Kike 16/07) */
    var todas = all.filter(function(i){ return i.count >= 3; })
      .slice().sort(function(a, b){ return a.name.localeCompare(b.name, "es"); });
    var hero = items[0];
    /* En foco = top-3 tras la marca del momento, con swap Kiblo Caps → Represent
       (cambio Kike 12/07); Kiblo baja al mosaico. Re-ordenado por profundidad. */
    var focusNames = items.slice(1, 4).map(function(i){ return i.name === "KIBLO CAPS" ? "REPRESENT" : i.name; });
    var focus = items.filter(function(i){ return focusNames.indexOf(i.name) >= 0; });
    var rest = items.filter(function(i){ return i !== hero && focus.indexOf(i) < 0; });
    var mosaic = rest.slice(0, 12);   // siguientes 12 → mosaico (editorial o foto de producto)

    var heroHTML = '<a class="mc-hero" href="' + url(hero.name) + '">' + imgTag(hero) + '<span class="mc-hero-scrim"></span>' +
      '<span class="mc-hero-top"><span class="mc-hero-kicker">Marca del momento</span></span>' +
      '<span class="mc-hero-meta"><span class="mc-hero-name">' + hero.name + '</span>' +
      '<span class="mc-hero-cta">Ver la marca ' + arrow(13) + '</span></span></a>';

    var focusHTML = '<section class="mc-focus-stack">' + focus.map(function(f){
      return '<a class="mc-focus" href="' + url(f.name) + '">' + imgTag(f) + '<span class="mc-focus-scrim"></span>' +
        '<span class="mc-focus-meta"><span class="mc-focus-name">' + f.name + '</span>' +
        '<span class="mc-focus-foot"><span class="mc-focus-count">' + pcs(f.count) + '</span>' +
        '<span class="mc-focus-cta">Ver ' + arrow(12) + '</span></span></span></a>';
    }).join("") + '</section>';

    /* mosaico: nombre sobre la foto con scrim (mismo tratamiento que hero/En foco),
       sin texto secundario (cambio Kike 12/07 — fuera el cuadro blanco con conteo) */
    var mosaicHTML = '<div class="mb-grid">' + mosaic.map(function(b){
      return '<a class="mb-tile" href="' + url(b.name) + '"><span class="mb-tile-frame">' + imgTag(b) +
        '<span class="mb-tile-scrim"></span>' +
        '<span class="mb-tile-name">' + b.name + '</span></span></a>';
    }).join("") + '</div>';

    var todasHTML = '<section class="mc-dir">' + todas.map(function(b){
      return '<a class="mc-dir-row" href="' + url(b.name) + '"><span class="mc-dir-name">' + b.name +
        '</span><span class="mc-dir-count">' + b.count + '</span></a>';
    }).join("") + '</section>';

    root.innerHTML = heroHTML +
      sechead("En foco", "Selección de la casa", false) + focusHTML +
      sechead("Más marcas", mosaic.length + " en la casa", false) + mosaicHTML +
      (todas.length ? sechead("Todas las marcas", todas.length + " casas", true) + todasHTML : "") +
      '<div class="mc-foot-note"><p>¿No ves la marca que buscas? ' +
      '<a class="mc-foot-link" data-track="fake-door-marcas" href="' + WA_DOOR + '" target="_blank" rel="noopener">Te la conseguimos ' + arrow(12) + '</a></p></div>';
    });
  });
})();
